module.exports = __webpack_public_path__ + "static/media/tick.c1ac6b97.svg";